<!-- 
<div class="sponsor-detail-container" style="overflow-y: auto;">

  <div class="toggle-container">
    <mat-slide-toggle labelPosition="before" [(ngModel)]="showSponsors" class="slide-toggle">
      Show Sponsors
    </mat-slide-toggle>
  </div>

  <mat-card *ngIf="showSponsors">
    <h3>{{ editMode ? 'Edit Sponsor' : 'Add Sponsor' }}</h3>
    <div class="form-group">
      <mat-form-field appearance="fill">
        <mat-label>Sponsor Name</mat-label>
        <input matInput [(ngModel)]="newSponsorName" (ngModelChange)="checkNameExists(newSponsorName)" />
      </mat-form-field>
      <div *ngIf="nameExists" class="error">
        Sponsor name already exists. Please choose a different name.
      </div>
    </div>

    <div class="form-group">
      <mat-form-field appearance="fill">
        <mat-label>Image Frequency</mat-label>
        <input matInput type="number" [(ngModel)]="newSponsorImageFrequency" />
      </mat-form-field>
      <p style="font-style: italic;font-size: 10px;color: gray;">The number of slides after which sponsor images would show</p>

    </div>

    <div class="form-group">
      <label for="file-upload" class="file-upload-label">
        <span class="upload-text">Select Image</span>
      </label>

      <input id="file-upload" (change)="onFileChange($event)" type="file" multiple accept=".png, .jpg, .jpeg,.webp"
        class="file-upload-input">

      <div *ngIf="fileTypeError" class="error-message">
        Only PNG, JPG and WEBP files are allowed.
      </div>

    </div>

    <div class="image-preview">
      <h3>Image Preview</h3>
      <div *ngFor="let image of newSponsorImages; let i = index" class="image-container">
        <img [src]="image" alt="Sponsor Image" />
        <button mat-icon-button color="warn" (click)="removeImage(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="!editMode">
      <button mat-raised-button class="save-button" [disabled]="nameExists" (click)="saveSponsor()">Save</button>
    </div>
    <div *ngIf="editMode">
      <button mat-raised-button class="save-button" (click)="saveSponsor()">Update</button>
      <button mat-raised-button class="cancel-button" (click)="onCancel()">Cancel</button>
    </div>
  </mat-card>
  <div *ngIf="!showSponsors">
    <button mat-raised-button class="save-button" (click)="saveSponsor()">Save</button>
  </div>
  <div class="sponsor-list" *ngIf="showSponsors">
    <h2>Sponsors List</h2>
    <mat-list>
      <mat-list-item *ngFor="let sponsor of sponsors; let i = index">
        <mat-card class="sponsor-item">
          <h3>{{ sponsor.name }}</h3>
          <p>Image Frequency: {{ sponsor.imageFrequency }}</p>
          <div class="images">
            <img *ngFor="let image of sponsor.images" [src]="image" alt="Sponsor Image" />
          </div>
          <div class="action-buttons">
            <button mat-raised-button color="primary" (click)="editSponsor(sponsor.id,i)">Edit</button>
            <button mat-raised-button color="warn" (click)="deleteSponsor(sponsor.id,i)">Delete</button>
          </div>
        </mat-card>
      </mat-list-item>
    </mat-list>
  </div>
</div> -->
<div class="sponsor-detail-container" style="overflow-y: auto;">
  <!-- Mat Slide Toggle to Show/Hide Sponsors List -->
  <div class="toggle-container">
    <mat-slide-toggle labelPosition="before" [(ngModel)]="showSponsors" (change)="onToggleChange($event)"  class="slide-toggle">
      Show Sponsors
    </mat-slide-toggle>
  </div>

  <!-- Button to Add Sponsor -->
  <button mat-raised-button color="primary" (click)="openAddSponsorPopup()" *ngIf="!isPopupOpen && showSponsors">
    Add Sponsor
  </button>
  <div style="top: 3%;text-align: center;width: 60%;bottom: 2%;" class="alert alert-info" *ngIf="showMessage !== ''">{{ showMessage }}</div>
  <!-- Popup Form for Adding/Editing Sponsor -->
  <div class="popup-form" *ngIf="isPopupOpen  && showSponsors">
    <mat-card>
      <h2>{{ editMode ? 'Edit Sponsor' : 'Add Sponsor' }}</h2>
      <div class="form-group">
        <mat-form-field appearance="fill">
          <mat-label>Sponsor Name</mat-label>
          <input matInput [(ngModel)]="newSponsorName" (ngModelChange)="checkNameExists(newSponsorName)" />
        </mat-form-field>
        <div *ngIf="nameExists" class="error">
          Sponsor name already exists. Please choose a different name.
        </div>
      </div>

      <div class="form-group">
        <mat-form-field appearance="fill">
          <mat-label>Image Frequency</mat-label>
          <input matInput type="number" [(ngModel)]="newSponsorImageFrequency" />
        </mat-form-field>
        <p style="font-style: italic;font-size: 10px;color: gray;">
          The number of slides after which sponsor images would show
        </p>
      </div>

      <div class="form-group">
        <label for="file-upload" class="file-upload-label">
          <span class="upload-text">Select Image</span>
        </label>
        <input id="file-upload" (change)="onFileChange($event)" type="file" multiple accept=".png, .jpg, .jpeg, .webp"
          class="file-upload-input">
        <div *ngIf="fileTypeError" class="error-message">
          Only PNG, JPG, and WEBP files are allowed.
        </div>
      </div>

      <div class="image-preview">
        <h3>Image Preview</h3>
        <div *ngFor="let image of newSponsorImages; let i = index" class="image-container">
          <img [src]="image" alt="Sponsor Image" />
          <button mat-icon-button color="warn" (click)="removeImage(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="!editMode">
        <button mat-raised-button class="save-button" [disabled]="nameExists" (click)="saveSponsor()">Save</button>
        <button mat-raised-button class="cancel-button" (click)="closePopup()">Cancel</button>

      </div>
      <div *ngIf="editMode">
        <button mat-raised-button class="save-button" (click)="saveSponsor()">Update</button>
        <button mat-raised-button class="cancel-button" (click)="onCancel()">Cancel</button>
      </div>
    </mat-card>
  </div>
  <div class="overlay" *ngIf="isSavingData">
    <!-- <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div> -->
     <span class="loader"></span>
  </div>
  <!-- Sponsors List -->
  <div class="sponsor-list" *ngIf="showSponsors">
    <h2>Sponsors List</h2>
    <mat-list>
      <mat-list-item *ngFor="let sponsor of sponsors; let i = index">
        <mat-card class="sponsor-item">
          <h3>{{ sponsor.name }}</h3>
          <p>Image Frequency: {{ sponsor.imageFrequency }}</p>
          <div class="images">
            <img *ngFor="let image of sponsor.images" [src]="image" alt="Sponsor Image" />
          </div>
          <div class="action-buttons">
            <button mat-raised-button color="primary" (click)="editSponsor(sponsor.id, i)">Edit</button>
            <button mat-raised-button color="warn" (click)="deleteSponsor(sponsor.id, i)">Delete</button>
          </div>
        </mat-card>
      </mat-list-item>
    </mat-list>
  </div>
</div>